import { useMutation } from "@tanstack/react-query";
import { iam_api_requests, public_iam_api_requests } from "..";
import {
  BrowserSessionDTO,
  CreateBrowserSessionRequest,
  UpdateBrowserSessionRequest,
} from "./types";
import { SESSION_DB_ID_STORAGE } from "../../../hooks/useBrowserTracking";

const PATH = "/browser-sessions";

// Create Browser Session
export const useCreateBrowserSession = () => {
  return useMutation({
    mutationFn: async (request: CreateBrowserSessionRequest) =>
      public_iam_api_requests.post<BrowserSessionDTO>(PATH, request),
    onSuccess: (data, variables, context) => {
      console.log("Storing browser session DB ID in sessionStorage:", data);
      sessionStorage.setItem(SESSION_DB_ID_STORAGE, data.id.toString());
    },
  });
};

// Update Browser Session
export const useUpdateBrowserSession = () => {
  return useMutation({
    mutationFn: async ({
      id,
      data,
    }: {
      id: number;
      data: UpdateBrowserSessionRequest;
    }) => {
      const response = await iam_api_requests.put<BrowserSessionDTO>(
        `${PATH}/${id}`,
        data
      );
      return response.data;
    },
  });
};

// Direct API calls (without React Query hooks) for use in non-component contexts
export const browserSessionApi = {
  create: async (
    request: CreateBrowserSessionRequest
  ): Promise<BrowserSessionDTO> => {
    const response = await public_iam_api_requests.post<BrowserSessionDTO>(
      PATH,
      request
    );
    return response.data;
  },

  get: async (id: number): Promise<BrowserSessionDTO> => {
    const response = await public_iam_api_requests.get(`${PATH}/${id}`);
    return response;
  },

  update: async (
    id: number,
    data: UpdateBrowserSessionRequest
  ): Promise<BrowserSessionDTO> => {
    const response = await iam_api_requests.put<BrowserSessionDTO>(
      `${PATH}/${id}`,
      data
    );
    return response.data;
  },
};
